import React from 'react'
import { Card, StatusBadge } from './Ui'

export function BackLink({ onClick, children = '목록으로 돌아가기' }) {
  return <button className="admin-back-link" type="button" onClick={onClick}>← {children}</button>
}

export function EntityNotFound({ entity = '데이터', id, onBack }) {
  return (
    <>
      {onBack && <BackLink onClick={onBack} />}
      <Card>
        <div className="admin-empty-inline">
          <strong>{entity}를 찾을 수 없습니다.</strong>
          <p>{id ? `요청 ID: ${id}` : '요청한 데이터가 없거나 더 이상 조회할 수 없습니다.'}</p>
        </div>
      </Card>
    </>
  )
}

export function SummaryGrid({ items }) {
  return (
    <div className="admin-summary-grid">
      {items.map((item) => (
        <div key={item.label} className="admin-summary-item">
          <span>{item.label}</span>
          <strong>{item.value ?? '-'}</strong>
          {item.description && <small>{item.description}</small>}
        </div>
      ))}
    </div>
  )
}

export function DetailGrid({ items, columns = 2 }) {
  return (
    <div className={`admin-detail-grid columns-${columns}`}>
      {items.map((item) => (
        <div key={item.label} className={item.wide ? 'is-wide' : ''}>
          <span>{item.label}</span>
          <strong>{item.value ?? '-'}</strong>
          {item.description && <p>{item.description}</p>}
        </div>
      ))}
    </div>
  )
}

export function Timeline({ items = [] }) {
  if (!items.length) return <div className="admin-empty-inline">등록된 이력이 없습니다.</div>
  return (
    <div className="admin-timeline">
      {items.map((item, index) => (
        <div key={`${item.label}-${index}`}>
          <i />
          <div><strong>{item.label}</strong>{item.detail && <p>{item.detail}</p>}</div>
          <time>{item.at || item.date || '-'}</time>
        </div>
      ))}
    </div>
  )
}

export function Tags({ items = [] }) {
  return <div className="admin-tag-list">{items.length ? items.map((item) => <span key={item}>{item}</span>) : <span className="is-empty">-</span>}</div>
}

export function RelatedTable({ headers, rows, onRowClick }) {
  return (
    <div className="table-scroll">
      <table className="data-table admin-related-table">
        <thead><tr>{headers.map((header) => <th key={header}>{header}</th>)}</tr></thead>
        <tbody>
          {rows.length ? rows.map((row) => (
            <tr key={row.key} onClick={() => onRowClick?.(row)}>
              {row.cells.map((cell, index) => <td key={index}>{cell}</td>)}
            </tr>
          )) : <tr><td colSpan={headers.length}><div className="admin-table-empty">표시할 데이터가 없습니다.</div></td></tr>}
        </tbody>
      </table>
    </div>
  )
}

export function StatusSummary({ label, status, description }) {
  return (
    <Card className="status-summary-card">
      <div className="status-summary-inline">
        <div><span>{label}</span><StatusBadge status={status} /></div>
        {description && <p>{description}</p>}
      </div>
    </Card>
  )
}
